import {useDispatch, useSelector} from "react-redux";
import {cloneDeep} from "lodash";
import {setAvoStories2CampaignBannerDetail} from "../../../reducers/avo-stories-2.reducer";
import InputComponent from "../../../components/input.component";
import React from "react";

const ItemCampaignBanner = ({fieldList, index}) => {
    const dispatch = useDispatch()
    const {campaignBannerDetail, avoStories2ErrorMessage} = useSelector(state => state.avoStories2Reducer)

    const onChange = (key, value) => {
        const copyItemList = cloneDeep(campaignBannerDetail?.item_list)
        copyItemList[index][key] = value
        dispatch(setAvoStories2CampaignBannerDetail({item_list: copyItemList}))
    }

    return (
        <div className={"grid grid-cols-2 gap-x-16 gap-y-4"}>
            {fieldList.map((item, i) => (
                <InputComponent key={i} item={item} data={campaignBannerDetail?.item_list?.[index]?.[item.key]} error={avoStories2ErrorMessage[`item_list[${index}]`] ?? {}} onChange={onChange} onChangeInput={onChange}/>
            ))}
        </div>
    )
}

export default ItemCampaignBanner
